import {Component, OnInit} from '@angular/core';
import {UserModel} from '../../models/user.model';
import {ReportService} from '../../services/report.service';
import {PublicationService} from '../../services/publication.service';
import {AppCommunicationService} from '../../services/app-communication.service';
import {UserRolePipe} from '../../pipes/user-role.pipe';

@Component({
    selector: 'app-dashboard-view',
    templateUrl: './dashboard-view.component.html',
    styleUrls: ['./dashboard-view.component.scss']
})
export class DashboardViewComponent implements OnInit {
    userFirstName = '';
    isbnReportsCount= 0;
    pvReportsCount= 0;
    newApplyCount= 0;
    constructor(private reportService:ReportService,
                private publicationService:PublicationService,
                private userRolePipe:UserRolePipe) {
    }


    ngOnInit() {

        this.userFirstName = AppCommunicationService.getCurrentUser().user.name;
        if(this.userRolePipe.transform(['SUPERADMIN','UK_ADMIN', 'ISBN_UK_ADMIN'])) {
            this.publicationService.getNewPublicaitonCount()
                .subscribe((respons:number)=> {this.newApplyCount=respons;},(err)=>console.error(err));
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/+app-custom/views/dashboard-view/dashboard-view.component.ts